// R1/LGPD — versão dos Termos/Política aceita no checkout. Vai no payload e é
// gravada no consentimento (Subscription.termsVersion). Bump quando o texto mudar.
//
// Arquivo próprio (2026-10-20): o checkout padrão e o do Reservei registram o
// MESMO aceite; duas constantes divergiriam no dia do bump.
// 2026-10-26: termos vigentes (antes 'v0-draft', rascunho) — ver pages/legal/termos-de-uso.tsx.
export const CHECKOUT_TERMS_VERSION = '2026-10-26';
